// extracted by mini-css-extract-plugin
export default {"sticky_banner":"mz96z","logoContainer":"I505J","logo_override":"PtPZG","#":"Kh7Fc"};